import { Routes, Route, Navigate } from 'react-router-dom';

import { RequireIsLoggedIn, RequireIsAnonymous, useAuth } from 'common/auth';
import { NotFound } from 'common/components';

import AuthContainer from 'features/auth';
import { AUTH_ROUTES } from 'features/auth/routes';
import DashboardContainer from 'features/dashboard';
import { DASHBOARD_ROUTES } from 'features/dashboard/routes';
import { AGENT_ROUTES } from 'features/agent/routes';
import AgentContainer from 'features/agent';
import { RECEIPT_ROUTES } from 'features/receipt/routes';
import ReceiptContainer from 'features/receipt/index';
import { MASTER_ROUTES } from 'features/master/routes';
import MasterContainer from 'features/master/indext';
import { NACH_ROUTE } from 'features/nach/routes';
import NachContainer from 'features/nach';
import NachCustomerRedirectContainer from 'features/nach/customers_redirect_page';
import { customer_routes } from 'features/nach/customers_redirect_page/routes';
import { PAYMENT_REQUEST_HOSTORY_ROUTES } from 'features/paymentRequestHistory/routes';
import PaymentRequestHistory from 'features/paymentRequestHistory';
// import paymentRequestHistory from 'features/nach/customers_redirect_page';
// import { customer_routes } from 'features/nach/customers_redirect_page/routes';

const rootPath = '/';

const App = () => {
  const { isLoggedIn } = useAuth();

  return (
    <Routes>
      <Route
        path={rootPath}
        element={
          <Navigate replace to={isLoggedIn ? DASHBOARD_ROUTES.index.to : AUTH_ROUTES.index.to} />
        }
      />
      <Route
        path={AUTH_ROUTES.index.path}
        element={
          <RequireIsAnonymous redirectTo={rootPath}>
            <AuthContainer />
          </RequireIsAnonymous>
        }
      />
      <Route
        path={DASHBOARD_ROUTES.index.path}
        element={
          <RequireIsLoggedIn redirectTo={rootPath}>
            <DashboardContainer />
          </RequireIsLoggedIn>
        }
      />
      <Route
        path={AGENT_ROUTES.index.path}
        element={
          <RequireIsLoggedIn redirectTo={rootPath}>
            <AgentContainer />
          </RequireIsLoggedIn>
        }
      />
      <Route path="*" element={<NotFound />} />

      <Route
        path={RECEIPT_ROUTES.index.path}
        element={
          <RequireIsLoggedIn redirectTo={rootPath}>
            <ReceiptContainer />
          </RequireIsLoggedIn>
        }
      />
      <Route
        path={MASTER_ROUTES.index.path}
        element={
          <RequireIsLoggedIn redirectTo={rootPath}>
            <MasterContainer />
          </RequireIsLoggedIn>
        }
      />

      <Route
        path={NACH_ROUTE.index.path}
        element={
          <RequireIsLoggedIn redirectTo={rootPath}>
            <NachContainer />
          </RequireIsLoggedIn>
        }
      />

      <Route path={customer_routes.index.path} element={<NachCustomerRedirectContainer />}></Route>
      <Route
        path={PAYMENT_REQUEST_HOSTORY_ROUTES.index.path}
        element={
          <RequireIsLoggedIn redirectTo={rootPath}>
            <PaymentRequestHistory />
          </RequireIsLoggedIn>
        }
      ></Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
